module.exports = __webpack_public_path__ + "images/9fb5e5b21cc984e3b54c7907c4499340.jpg";